import * as React from "react";
import { FunctionComponent } from "react";
import "./MiniBoard.css";

const PLAYER1_PITS = [0, 1, 2, 3, 4, 5];
const PLAYER2_PITS = [7, 8, 9, 10, 11, 12];
const PLAYER1_STORE = 6;
const PLAYER2_STORE = 13;

// Stone counts on a small board, as the bottom player sees it. Empty pits show no number. `played` and `landed` mark
// a move: the pit played and where its last stone landed.
const MiniBoard: FunctionComponent<{
    board: number[], revert?: boolean, large?: boolean, played?: number, landed?: number,
}> = ({ board, revert, large, played, landed }) => {
    const [topPits, topStore, bottomPits, bottomStore] = revert
        ? [PLAYER1_PITS, PLAYER1_STORE, PLAYER2_PITS, PLAYER2_STORE]
        : [PLAYER2_PITS, PLAYER2_STORE, PLAYER1_PITS, PLAYER1_STORE];
    const marks = (index: number) => (index === played ? " played" : "") + (index === landed ? " land" : "");
    const pit = (index: number) => <div key={index} className={"mp" + marks(index)}>{board[index] || ""}</div>;
    return (
        <div className={"mini" + (large ? " lg" : "")} aria-hidden="true">
            <div className={"ms l" + marks(topStore)}>{board[topStore]}</div>
            {[...topPits].reverse().map(pit)}
            <div className={"ms r" + marks(bottomStore)}>{board[bottomStore]}</div>
            {bottomPits.map(pit)}
        </div>
    );
};

export const getStores = (board: number[], revert?: boolean) => revert
    ? { top: board[PLAYER1_STORE], bottom: board[PLAYER2_STORE] }
    : { top: board[PLAYER2_STORE], bottom: board[PLAYER1_STORE] };

export default MiniBoard;
